import styled from "styled-components";

export const StyledFormContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: ${(props: any) => props.align};
  .login {
    display: block;
    text-align: center;
    color: #27548c;
    transition: 0.5s;
    margin-bottom: 1rem;
    &:hover {
      text-decoration: underline;
    }
  }
`;
